import { Tooltip } from '@/components';
import { AlertIcon } from '@/components/Icons';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import { ICaregiverConsultationDto } from '@/caregiverSpace/shared/model';

type JournalNotesStatusProps = {
    consultation: ICaregiverConsultationDto;
};

export const JournalNotesStatus = ({
    consultation,
}: JournalNotesStatusProps) => {
    if (!consultation.HasJournalNotes && consultation.IsVideo) {
        return (
            <Tooltip content={R.JournalNoteMissing} allowTextWrap={true}>
                <AlertIcon variant="error" />
            </Tooltip>
        );
    }
};
